import React from 'react';

import classNames from 'classnames';

export default function Action({
  icon,
  actionTitle,
  actionDescription,
  handleClose,
  onClick,
  disabled,
}) {
  return (
    <li className="border-b border-slate-200 dark:border-slate-700 last:border-0 cursor-pointer w-full">
      <button
        type="button"
        disabled={disabled}
        className={classNames('py-2 px-4 text-left w-full', {
          'hover:bg-slate-50 dark:hover:bg-slate-700/20': !disabled,
          'cursor-not-allowed opacity-60': disabled,
        })}
        onClick={() => {
          onClick();
          handleClose();
        }}
      >
        <span className="block text-sm mb-2">
          <span className="inline-flex items-center gap-1">
            {icon && <span className="[&_svg]:inline-block">{icon}</span>}
            <span className="font-medium text-slate-800 dark:text-slate-100">
              {actionTitle}
            </span>
          </span>
          <br />
          <span className="text-slate-600 font-normal">
            {actionDescription}
          </span>
        </span>
      </button>
    </li>
  );
}
